const normalizeAirportCode = (code) => (code || '').trim().toUpperCase();

const normalizeDate = (date) => {
  if (!date) {
    return '';
  }

  const trimmed = String(date).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return trimmed;
  }

  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) {
    return trimmed;
  }

  return parsed.toISOString().slice(0, 10);
};

export const buildGoogleFlightsUrl = ({
  origin,
  destination,
  departDate,
  returnDate,
  passengers,
}) => {
  const from = normalizeAirportCode(origin);
  const to = normalizeAirportCode(destination);
  const departure = normalizeDate(departDate);

  if (!from || !to || !departure) {
    return null;
  }

  let query = `Flights from ${from} to ${to} on ${departure}`;

  const normalizedReturnDate = normalizeDate(returnDate);
  if (normalizedReturnDate) {
    query += ` returning ${normalizedReturnDate}`;
  }

  const passengerCount = parseInt(passengers, 10);
  if (!Number.isNaN(passengerCount) && passengerCount > 1) {
    query += ` for ${passengerCount} passengers`;
  }

  return `https://www.google.com/travel/flights?q=${encodeURIComponent(query)}`;
};

export const openGoogleFlightsInNewTab = (params) => {
  const url = buildGoogleFlightsUrl(params);
  if (!url) {
    return false;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
};
